import React from 'react';
import PropTypes from 'prop-types';
import { Typo, Card, Spinner, ErrorBoundary } from '@ers/ui';

import { Offer } from '.';
import { Files, PersonalData, AdditionalData, ContactData, ContactDataFull, ClausesAndConsents } from './bodyComponents';
import { useForm } from '../Form.hooks';

const FormBody = ({ applicationId }) => {
    const { isLoading, form, translations } = useForm(applicationId);
    return isLoading ? (
        <Spinner />
    ) : (
        <>
            <Card slim noShadow editable>
                <Typo.Caption className="with-margin--bottom-2">Ogłoszenie</Typo.Caption>
                <ErrorBoundary>
                    <Offer applicationId={applicationId} />
                </ErrorBoundary>
            </Card>
            <Card slim noShadow>
                <Typo.Caption className="with-margin--bottom-2">Wysłane pliki</Typo.Caption>
                <ErrorBoundary>
                    <Files form={form} translations={translations} />
                </ErrorBoundary>
            </Card>
            <Card slim noShadow editable>
                <Typo.Caption className="with-margin--bottom-2">Formularz aplikacyjny</Typo.Caption>
                <ErrorBoundary>
                    <PersonalData form={form} translations={translations} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <ContactData form={form} translations={translations} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <ContactDataFull form={form} translations={translations} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <AdditionalData form={form} translations={translations} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <ClausesAndConsents form={form} translations={translations} />
                </ErrorBoundary>
            </Card>
        </>
    );
};

FormBody.propTypes = {
    applicationId: PropTypes.number
};
FormBody.defaultProps = {
    applicationId: null
};

export default FormBody;


